// Auto-generated from questions.csv
// Do not edit manually

import { CSVRow } from '../lib/csvLoader';

export const questionsData: CSVRow[] = [
  {
    "id": "1",
    "number": "1",
    "question": "What color fits your perfect mood?",
    "backgroundPath": "/beauty-profiler/questions/1.avif",
    "type": "single-choice",
    "answerOptions": "1,2,3,4",
    "profiler": "beauty-profiler",
    "minLabel": "",
    "maxLabel": "",
    "variant": "black"
  },
  {
    "id": "2",
    "number": "2",
    "question": "Which pair of shoes unveils your allure ?",
    "backgroundPath": "/beauty-profiler/questions/2.avif",
    "type": "single-choice",
    "answerOptions": "5,6,7,8",
    "profiler": "beauty-profiler",
    "minLabel": "",
    "maxLabel": "",
    "variant": "white"
  },
  {
    "id": "3",
    "number": "3",
    "question": "How about your signature beauty move?",
    "backgroundPath": "/beauty-profiler/questions/3.avif",
    "type": "single-choice",
    "answerOptions": "9,10,11,12",
    "profiler": "beauty-profiler",
    "minLabel": "",
    "maxLabel": "",
    "variant": "white"
  },
  {
    "id": "4",
    "number": "4",
    "question": "What is your fashion inspiration?",
    "backgroundPath": "/beauty-profiler/questions/4.avif",
    "type": "single-choice",
    "answerOptions": "13,14,15,16",
    "profiler": "beauty-profiler",
    "minLabel": "",
    "maxLabel": "",
    "variant": "white"
  },
  {
    "id": "5",
    "number": "5",
    "question": "Imagine your dream weekend?",
    "backgroundPath": "/beauty-profiler/questions/5.avif",
    "type": "single-choice",
    "answerOptions": "17,18,19,20",
    "profiler": "beauty-profiler",
    "minLabel": "",
    "maxLabel": "",
    "variant": "white"
  },
  {
    "id": "6",
    "number": "6",
    "question": "Your beauty motto?",
    "backgroundPath": "/beauty-profiler/questions/6.avif",
    "type": "single-choice",
    "answerOptions": "21,22,23,24",
    "profiler": "beauty-profiler",
    "minLabel": "",
    "maxLabel": "",
    "variant": "white"
  },
  {
    "id": "7",
    "number": "7",
    "question": "Soulful Paris spot?",
    "backgroundPath": "/beauty-profiler/questions/7.avif",
    "type": "single-choice",
    "answerOptions": "25,26,27,28",
    "profiler": "beauty-profiler",
    "minLabel": "",
    "maxLabel": "",
    "variant": "white"
  },
  {
    "id": "8",
    "number": "8",
    "question": "If you could sip from a drink?",
    "backgroundPath": "/beauty-profiler/questions/8.avif",
    "type": "single-choice",
    "answerOptions": "29,30,31,32",
    "profiler": "beauty-profiler",
    "minLabel": "",
    "maxLabel": "",
    "variant": "white"
  },
  {
    "id": "9",
    "number": "9",
    "question": "Describe your favorite olfactive familly?",
    "backgroundPath": "/beauty-profiler/questions/9.avif",
    "type": "single-choice",
    "answerOptions": "33,34,35,36",
    "profiler": "beauty-profiler",
    "minLabel": "",
    "maxLabel": "",
    "variant": "white"
  },
  {
    "id": "10",
    "number": "10",
    "question": "If you had to choose one food to enjoy, which would it be ?",
    "backgroundPath": "/beauty-profiler/questions/10.avif",
    "type": "single-choice",
    "answerOptions": "37,38,39,40",
    "profiler": "beauty-profiler",
    "minLabel": "",
    "maxLabel": "",
    "variant": "white"
  },
  {
    "id": "11",
    "number": "1",
    "question": "Who will wear the fragrance ?",
    "backgroundPath": "/fragrance-profiler/questions/1.webm",
    "type": "single-choice",
    "answerOptions": "41,42",
    "profiler": "fragrance-profiler",
    "minLabel": "",
    "maxLabel": "",
    "variant": "white"
  },
  {
    "id": "12",
    "number": "2",
    "question": "How do you want her/him to feel wearing a Christian Louboutin fragrance ?",
    "backgroundPath": "/fragrance-profiler/questions/2.webm",
    "type": "single-choice",
    "answerOptions": "43,44,45,46",
    "profiler": "fragrance-profiler",
    "minLabel": "",
    "maxLabel": "",
    "variant": "white"
  },
  {
    "id": "13",
    "number": "3",
    "question": "Which of these scents matches your personality?",
    "backgroundPath": "/fragrance-profiler/questions/3.webm",
    "type": "single-choice",
    "answerOptions": "47,48,49,50",
    "profiler": "fragrance-profiler",
    "minLabel": "",
    "maxLabel": "",
    "variant": "white"
  },
  {
    "id": "14",
    "number": "4",
    "question": "How intense you like your fragrance?",
    "backgroundPath": "/fragrance-profiler/questions/4.webm",
    "type": "slider",
    "answerOptions": "51,52,53,54",
    "profiler": "fragrance-profiler",
    "minLabel": "Delicate",
    "maxLabel": "Intense",
    "variant": "black"
  }
];
